/* Nouveau Ciel · pré-lancement
   1. Provenance des inscriptions : ajoute au champ contact[tags] de tout formulaire client
      les tags UTM et le site d'origine (presse, réseaux), mémorisés 30 jours.
   2. Fenêtre d'inscription : ouverture différée ou au défilement, mise en veille après fermeture,
      réouverture sur l'état de confirmation ou d'erreur après envoi, liens #nc-invitation. */
(() => {
  'use strict';

  const local = {
    get(key) {
      try { return window.localStorage.getItem(key); } catch (error) { return null; }
    },
    set(key, value) {
      try { window.localStorage.setItem(key, value); } catch (error) { /* stockage indisponible : on continue sans mémoire */ }
    },
  };

  const DEFAULT_REFERRERS = 'leparisien.fr=presse-le-parisien\npublic.fr=presse-public\ninstagram.com=instagram\nfacebook.com=facebook\nyoutube.com=youtube\ngoogle.=google';
  const SOURCE_KEY = 'nc_source_tags';
  const SOURCE_TTL = 30 * 24 * 60 * 60 * 1000;

  const slug = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);

  function readConfig() {
    const node = document.getElementById('nc-prelaunch-config');
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}'); } catch (error) { return {}; }
  }

  const config = readConfig();

  function referrerRules() {
    const raw = typeof config.referrers === 'string' && config.referrers.trim() ? config.referrers : DEFAULT_REFERRERS;
    return raw
      .split(/\r?\n/)
      .map((line) => line.split('='))
      .filter((pair) => pair.length === 2 && pair[0].trim() && pair[1].trim())
      .map(([domain, tag]) => [domain.trim().toLowerCase(), slug(tag)]);
  }

  function detectSourceTags() {
    const tags = [];
    const params = new URLSearchParams(window.location.search);
    [['utm_source', 'source-'], ['utm_medium', 'canal-'], ['utm_campaign', 'campagne-']].forEach(([key, prefix]) => {
      const value = slug(params.get(key));
      if (value) tags.push(prefix + value);
    });
    let host = '';
    try { host = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (error) { host = ''; }
    if (host && host !== window.location.hostname.toLowerCase()) {
      const rule = referrerRules().find(([domain]) => host.includes(domain));
      tags.push(rule ? rule[1] : 'ref-' + slug(host.replace(/^www\./, '')));
    }
    return tags.filter(Boolean);
  }

  function sourceTags() {
    const fresh = detectSourceTags();
    if (fresh.length) {
      local.set(SOURCE_KEY, JSON.stringify({ at: Date.now(), tags: fresh }));
      return fresh;
    }
    try {
      const saved = JSON.parse(local.get(SOURCE_KEY) || 'null');
      if (saved && Date.now() - saved.at < SOURCE_TTL && Array.isArray(saved.tags)) return saved.tags;
    } catch (error) { /* valeur illisible : ignorée */ }
    return [];
  }

  const landingTags = sourceTags();

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !landingTags.length) return;
    const input = form.querySelector('input[name="contact[tags]"]');
    if (!input) return;
    const merged = new Set(input.value.split(',').map((tag) => tag.trim()).filter(Boolean));
    landingTags.forEach((tag) => merged.add(tag));
    input.value = Array.from(merged).join(',');
  }, true);

  /* ---------- Fenêtre d'inscription ---------- */
  const root = document.querySelector('[data-nc-invite]');
  const dialog = root ? root.querySelector('[data-nc-invite-dialog]') : null;
  if (!root || !dialog) return;

  const floatButton = root.querySelector('[data-nc-invite-float]');
  const formId = root.getAttribute('data-form-id') || 'NcInvitationPopup';
  const DONE_KEY = 'nc_invite_done';
  const SNOOZE_KEY = 'nc_invite_closed_until';
  const params = new URLSearchParams(window.location.search);
  const justPosted = params.get('customer_posted') === 'true';
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  let lastFocus = null;
  let autoTimer = null;
  let onScroll = null;

  function disarmAuto() {
    window.clearTimeout(autoTimer);
    if (onScroll) {
      window.removeEventListener('scroll', onScroll);
      onScroll = null;
    }
  }

  if (justPosted) local.set(DONE_KEY, '1');
  const isDone = () => local.get(DONE_KEY) === '1';
  const isSnoozed = () => Number(local.get(SNOOZE_KEY) || 0) > Date.now();

  const inlineSection = document.getElementById('nc-invitation');
  let inlineSectionVisible = false;
  let floatArmed = false;

  function setFloatVisible(visible) {
    if (floatButton) floatButton.hidden = !floatArmed || !visible || isDone() || dialog.open || inlineSectionVisible;
  }

  if (inlineSection && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      inlineSectionVisible = entries.some((entry) => entry.isIntersecting);
      setFloatVisible(true);
    }, { threshold: 0.15 }).observe(inlineSection);
  }

  function openDialog(options = {}) {
    if (dialog.open) return;
    disarmAuto();
    lastFocus = document.activeElement;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('nc-invite-lock');
    setFloatVisible(false);
    if (options.focusEmail) {
      const email = dialog.querySelector('input[type="email"]');
      if (email) email.focus({ preventScroll: true });
    }
  }

  function closeDialog() {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.dispatchEvent(new Event('close'));
    }
  }

  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('nc-invite-lock');
    if (!isDone()) {
      const days = Number(root.getAttribute('data-reshow-days')) || 7;
      local.set(SNOOZE_KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
    }
    setFloatVisible(true);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  });

  root.querySelectorAll('[data-nc-invite-close]').forEach((button) => {
    button.addEventListener('click', closeDialog);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
    if (!inside) closeDialog();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('a[href$="#nc-invitation"], [data-nc-invite-open]') : null;
    if (!trigger) return;
    event.preventDefault();
    openDialog({ focusEmail: true });
  });

  const hash = window.location.hash;
  const hasError = Boolean(dialog.querySelector('[data-nc-invite-error]'));
  const returnedToPopup = hash === '#' + formId;
  const returnedElsewhere = hash && hash !== '#' + formId && hash !== '#nc-invitation';

  if (hasError && !returnedElsewhere) {
    openDialog({ focusEmail: true });
  } else if (justPosted && returnedToPopup) {
    openDialog();
  } else if (hash === '#nc-invitation') {
    openDialog({ focusEmail: true });
  } else if (!isDone() && !isSnoozed() && !designMode && root.getAttribute('data-auto') === 'true') {
    const delay = Math.max(0, Number(root.getAttribute('data-delay')) || 0) * 1000;
    autoTimer = window.setTimeout(() => openDialog(), delay);
    onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max > 0.45) openDialog();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  window.setTimeout(() => {
    floatArmed = true;
    setFloatVisible(true);
  }, designMode ? 0 : 2500);
})();
